module.exports = __webpack_public_path__ + "static/media/basura.328c9476.jpg";